<template>
  <div
    v-if="user_bry_certificate"
    class="certificate-status-display"
    :class="user_bry_certificate.result"
  >
    <div class="status-content">
      <div class="status-icon">
        <i :class="getStatusIcon(user_bry_certificate.result)"></i>
      </div>
      <div class="status-info">
        <h4 class="status-title">
          {{ getStatusTitle(user_bry_certificate.result) }}
        </h4>
        <p class="status-message">
          {{ getStatusMessage(user_bry_certificate.result) }}
        </p>

        <!-- Data adicional se disponível -->
        <div
          v-if="
            user_bry_certificate.created_at || user_bry_certificate.updated_at
          "
          class="status-meta"
        >
          <span v-if="user_bry_certificate.updated_at" class="meta-item">
            <i class="fas fa-clock mr-1"></i>
            Atualizado em: {{ formatDate(user_bry_certificate.updated_at) }}
          </span>
        </div>
      </div>
    </div>

    <!-- Progress indicator -->
    <div class="status-progress">
      <div
        class="progress-bar"
        :style="{
          width: getProgressPercentage(user_bry_certificate.result) + '%',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "../../../lib/format";

export default {
  name: "CertificateBRyResult",

  props: {
    user_bry_certificate: {
      type: [Object, Boolean],
      default: null,
    },
  },

  methods: {
    formatDate,

    getStatusIcon(result) {
      const icons = {
        received: "fas fa-inbox",
        in_validation: "fas fa-clock",
        approved: "fas fa-check-circle",
        issued: "fas fa-certificate",
        validation_rejected: "fas fa-times-circle",
        rejected: "fas fa-ban",
      };
      return icons[result] || "fas fa-question-circle";
    },

    getStatusTitle(result) {
      const titles = {
        received: "Solicitação Recebida",
        in_validation: "Em Validação",
        approved: "Solicitação Aprovada",
        issued: "Certificado Emitido",
        validation_rejected: "Validação Rejeitada",
        rejected: "Solicitação Rejeitada",
      };
      return titles[result] || "Status Desconhecido";
    },

    getStatusMessage(result) {
      const messages = {
        received: "Solicitação recebida com sucesso.",
        in_validation:
          "Solicitação já avaliada por um agente de registro e aguardando verificação pela central de verificação.",
        approved: "Solicitação aprovada e apta para emissão.",
        issued: "Certificado Digital emitido com sucesso.",
        validation_rejected:
          "Validação rejeitada pela central de verificação e reenviada para o posto de atendimento responsável.",
        rejected:
          "Solicitação rejeitada. Certificado digital não emitido. Fim do processo.",
      };
      return messages[result] || "Status não reconhecido.";
    },

    getProgressPercentage(result) {
      const percentages = {
        received: 25,
        in_validation: 50,
        approved: 100,
        issued: 100,
        validation_rejected: 50,
        rejected: 25,
      };
      return percentages[result] || 0;
    },
  },
};
</script>

<style scoped>
/* Certificate Status Display */
.certificate-status-display {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  margin: 16px 0;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.certificate-status-display:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.certificate-status-display::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #0f65b0 0%, #1e40af 100%);
}

/* Status Content */
.status-content {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
}

.status-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: white;
  flex-shrink: 0;
  background: #6b7280;
}

.status-info {
  flex: 1;
}

.status-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.status-message {
  font-size: 14px;
  font-weight: 400;
  color: #4b5563;
  line-height: 1.6;
  margin: 0 0 12px 0;
}

.status-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.meta-item {
  font-size: 12px;
  color: #6b7280;
  display: flex;
  align-items: center;
}

.mr-1 {
  margin-right: 4px;
}

/* Progress Bar */
.status-progress {
  width: 100%;
  height: 6px;
  background: #e5e7eb;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
}

.progress-bar {
  height: 100%;
  border-radius: 3px;
  transition: width 1s ease-in-out;
  background: #6b7280;
}

/* Status-specific styling */
.certificate-status-display.received {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  border-color: #60a5fa;
}

.certificate-status-display.received::before {
  background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);
}

.certificate-status-display.received .status-icon {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.certificate-status-display.received .status-title {
  color: #1e40af;
}

.certificate-status-display.received .progress-bar {
  background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
}

.certificate-status-display.in_validation {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  border-color: #f59e0b;
  animation: pulse-warning 3s infinite;
}

.certificate-status-display.in_validation::before {
  background: linear-gradient(180deg, #f59e0b 0%, #d97706 100%);
}

.certificate-status-display.in_validation .status-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  animation: pulse-icon 2s infinite;
}

.certificate-status-display.in_validation .status-title {
  color: #92400e;
}

.certificate-status-display.in_validation .progress-bar {
  background: linear-gradient(90deg, #f59e0b 0%, #d97706 100%);
  position: relative;
}

.certificate-status-display.in_validation .progress-bar::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: progress-shine 2s infinite;
}

@keyframes pulse-warning {
  0%,
  100% {
    box-shadow: 0 2px 8px rgba(245, 158, 11, 0.2);
  }
  50% {
    box-shadow: 0 4px 16px rgba(245, 158, 11, 0.4);
  }
}

@keyframes pulse-icon {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes progress-shine {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.certificate-status-display.approved {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border-color: #34d399;
}

.certificate-status-display.approved::before {
  background: linear-gradient(180deg, #10b981 0%, #059669 100%);
}

.certificate-status-display.approved .status-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.certificate-status-display.approved .status-title {
  color: #065f46;
}

.certificate-status-display.approved .progress-bar {
  background: linear-gradient(90deg, #10b981 0%, #059669 100%);
}

.certificate-status-display.issued {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border-color: #10b981;
  box-shadow: 0 4px 20px rgba(16, 185, 129, 0.2);
}

.certificate-status-display.issued::before {
  background: linear-gradient(180deg, #059669 0%, #047857 100%);
}

.certificate-status-display.issued .status-icon {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  box-shadow: 0 0 12px rgba(5, 150, 105, 0.3);
}

.certificate-status-display.issued .status-title {
  color: #065f46;
  font-weight: 700;
}

.certificate-status-display.issued .progress-bar {
  background: linear-gradient(90deg, #059669 0%, #047857 100%);
}

.certificate-status-display.validation_rejected,
.certificate-status-display.rejected {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border-color: #f87171;
}

.certificate-status-display.validation_rejected::before,
.certificate-status-display.rejected::before {
  background: linear-gradient(180deg, #ef4444 0%, #dc2626 100%);
}

.certificate-status-display.validation_rejected .status-icon,
.certificate-status-display.rejected .status-icon {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.certificate-status-display.validation_rejected .status-title,
.certificate-status-display.rejected .status-title {
  color: #991b1b;
}

.certificate-status-display.validation_rejected .progress-bar,
.certificate-status-display.rejected .progress-bar {
  background: linear-gradient(90deg, #ef4444 0%, #dc2626 100%);
}

/* Responsive Design */
@media (max-width: 768px) {
  .certificate-status-display {
    padding: 16px;
    margin: 12px 0;
  }

  .status-content {
    gap: 12px;
    margin-bottom: 12px;
  }

  .status-icon {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }

  .status-title {
    font-size: 15px;
  }

  .status-message {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .certificate-status-display {
    padding: 12px;
  }

  .status-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
  }

  .status-icon {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .status-title {
    font-size: 14px;
  }

  .status-message {
    font-size: 12px;
  }

  .meta-item {
    font-size: 11px;
  }
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .certificate-status-display {
    border-width: 2px;
  }

  .status-title {
    font-weight: 700;
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .certificate-status-display,
  .status-icon,
  .progress-bar,
  .certificate-status-display::after {
    animation: none !important;
    transition: none !important;
  }
}
</style>